import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination';

export function CustomPagination({ page, setPage, pageCount }) {
  const getPages = () => {
    const pages = [];

    const start = Math.max(1, page - 1);
    const end = Math.min(pageCount, page + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (page > 1) setPage(page - 1);
            }}
          />
        </PaginationItem>

        {page > 2 && (
          <>
            <PaginationItem>
              <PaginationLink href="#" onClick={() => setPage(1)}>
                1
              </PaginationLink>
            </PaginationItem>
            {page > 3 && <PaginationEllipsis />}
          </>
        )}

        {getPages().map((p) => (
          <PaginationItem key={p}>
            <PaginationLink
              className="!w-[35px]"
              href="#"
              isActive={p === page}
              onClick={(e) => {
                e.preventDefault();
                setPage(p);
              }}
            >
              {p}
            </PaginationLink>
          </PaginationItem>
        ))}

        {page < pageCount - 1 && (
          <>
            {page < pageCount - 2 && <PaginationEllipsis />}
            <PaginationItem>
              <PaginationLink href="#" onClick={() => setPage(pageCount)}>
                {pageCount}
              </PaginationLink>
            </PaginationItem>
          </>
        )}

        <PaginationItem>
          <PaginationNext
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (page < pageCount) setPage(page + 1);
            }}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
